// @flow
import { IMMERSIVE } from 'Client/cms/toolkit/constants';
import { ImmersiveLine } from 'Components/lines/immersive-line/ImmersiveLine';
import { immersiveResolver } from './immersive.resolver';

export const immersiveDescriptor = {
  name: IMMERSIVE,
  component: ImmersiveLine,
  resolver: immersiveResolver,
};
